/**
 * Product Module - gallery, variations, quantity, sticky bar.
 * Loaded on: Product pages only.
 * Placeholder for Phase 3.
 */

export function init() {
	// Phase 3: Product page interactivity.
}

// Auto-init when loaded.
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
